window.HGW = window.HGW || {};

HGW.utils = {
  toMinutes(timeStr) {
    if (!timeStr) return null;
    const [h, m] = timeStr.split(":").map(Number);
    if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
    return h * 60 + m;
  },

  minutesToTime(mins) {
    const h = String(Math.floor(mins / 60)).padStart(2, "0");
    const m = String(mins % 60).padStart(2, "0");
    return `${h}:${m}`;
  },

  startOfDay(d) {
    const c = new Date(d);
    c.setHours(0, 0, 0, 0);
    return c;
  },

  addDays(d, n) {
    const c = new Date(d);
    c.setDate(c.getDate() + n);
    return c;
  },

  formatISO(d) {
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  },

  parseISOLocal(iso) {
    const [y,m,d] = iso.split("-").map(Number);
    return new Date(y, m-1, d);
  },

  isToday(iso) {
    const t = new Date();
    const d = new Date(`${iso}T00:00:00`);
    return t.toDateString() === d.toDateString();
  },

  getWeekday(iso) {
    const d = HGW.utils.parseISOLocal(iso);
    return ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][d.getDay()];
  },

  formatEnglishDate(d) {
    return d.toLocaleDateString("en-AU", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  },

  formatSummaryDate(iso) {
  if (!iso) return "";
  const d = HGW.utils.parseISOLocal(iso);

    return d.toLocaleDateString("en-AU", {
      weekday: "short",
      day: "2-digit",
      month: "short",
    });
  }
};
